import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useState } from "react";

const useEditBudget = () => {
  const { lead } = useContext(LeadPageContext);
  const [editBudgetModalOpen, setEditBudgetModalOpen] = useState(false);
  const [budget, setBudget] = useState<number | null>(null);

  const handleChangeBudget = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBudget(Number(e.target.value));
  };
  return {
    budget: {
      editBudgetModalOpen,
      setEditBudgetModalOpen,
      handleChangeBudget,
      value: lead?.data?.lead?.budget ? lead?.data?.lead?.budget : 0,
      state: budget,
    },
  };
};
export default useEditBudget;
